import React from 'react';

import '../Footer/Footer.scss';

const Footer = () => {
  return (
    <>
    <footer style={{textAlign: 'center', padding: '20px', borderTop: '1px solid rgb(68 68 68 / 25%)'}}>
      <p>© 2020 - {new Date().getFullYear()} All Right Reserved - Portfolio By Rafay Dev.</p>
    </footer>
    </>
  )
}

export default Footer;
